import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class productReview_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `
                                                          
            <div class="w-form-body buyers-guide" data-bind="visible: idTemplate() == 5 || idTemplate() == 6 || idTemplate() == 8">
               <strong class="form-sub-title buyers-guide" data-bind="visible: idTemplate() == 5">PRODUCT REVIEW</strong>
               <strong class="form-sub-title buyers-guide" data-bind="visible: idTemplate() == 6">BUYERS GUIDE</strong>
               <strong class="form-sub-title buyers-guide" data-bind="visible: idTemplate() == 8">COLLECTION</strong>
                <!-- ko if: (idTemplate() == 5 && reviewItems().length == 0) || idTemplate() == 6 || idTemplate() == 8 -->
                <button id="plus_review" class="form-section-btn icon i-plus" data-bind="event: {click: onClickAddProduct}, hidden: (idStatus() == 6 && !permissions()['article_edit_publishingControl'].write && selectedTab() == 'article')" type="button"><span class="hide">Add a product</span></button>
                <!-- /ko -->
                
               <div class="form-body">
                    <!-- ----------------- -->
                    <!-- Intro text        -->
                    <!-- ----------------- -->
                    
                    <div class="form-group ">
                        <label data-bind="attr: {for: editorId() }" class="form-label">Intro Text</label>
                        <textarea data-bind="disable: isEditorDisable(), attr: {id: editorId()}"></textarea>   
                    </div>
              
               </div>
        

                <div class="form-body">
                    <div class="form-group">
                        <div class="w-img-article-list">
                            <ul class="img-article-list" data-bind="foreach: reviewItems, attr: { 'data-content': (idTemplate() == 5? 'product-review' : (idTemplate() == 6 ? 'buyers-guide' : (idTemplate() == 8 ? 'collection' : ''))) }" id="review-item-list">
                                <li class="img-article-item" draggable="true" data-bind="attr: {id: $index }">
                                    <button class="btn-icon icon i-drag" data-bind="hidden: ($parent.idStatus() == 6 && !$parent.permissions()['article_edit_publishingControl'].write && $parent.selectedTab() == 'article')"><span>drag</span></button>
                                    <div class="w-btn">
                                        <button class="btn-form icon i-delete" type="button" data-bind="hidden: ($parent.idStatus() == 6 && !$parent.permissions()['article_edit_publishingControl'].write && $parent.selectedTab() == 'article'), event: {click: $parent.onClickDeleteReviewItem.bind($data, $index())}"><span>delete</span></button>
                                        <button class="btn-form icon i-edit" type="button" data-bind="hidden: ($parent.idStatus() == 6 && !$parent.permissions()['article_edit_publishingControl'].write && $parent.selectedTab() == 'article'), event: {click: $parent.onClickEditReviewItem.bind($data, $index())}"><span>delete</span></button>
                                    </div>
                                    <div class="w-info">
                                        <span class="label icon " data-bind="class: tagAwardClass, text: award ? award.name : ''"></span>
                                        <div>
                                            <span data-bind="text: position" class="order"></span>
                                            <span data-bind="text: tag.name" class="title"></span>
                                        </div>
                                    </div>
                                    <div  class="ratio-content">
                                       <img data-bind="attr: { src: extraImages.length > 0 ? extraImages[0].url : '/assets/images/placeholder-product.png\' }" alt="image not found" />
                                    </div>
                                </li>
                                
                            </ul>
                        </div>
                        
                    </div>
                </div>
            </div>
             <div data-bind="css: { 'is-visible': isReviewItemDeleteVisible }" class="w-lightbox light-theme">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Confirm deletion of review item</h3>
                        </div>
                        
                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">Do you confirm the deletion of this item?</p>
                            </div>
                         </div>

                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickConfirmReviewItemDelete}" class="btn highlight">Confirm</button>
                            <button type="button" data-bind="event: { click: onClickCancelReviewItemDelete}" class="btn ">Cancel</button>
                        </div>
                        
                    </div>
                </div>
             </div>
               `;
    }

    protected initPartial():void{

        this.getTemplateViewModel().editorId(this.idElement + "_intro_text");
    }

    protected getTemplateName(): string{

        return "productReview_template";
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;

        return{
            editorId: ko.observable("")
            , idTemplate: ko.observable(null)
            , idStatus: ko.observable(null)
            , reviewItemToDelete: ko.observable(null)
            , reviewItems: ko.observableArray([])
            , reviewItemsToDelete: ko.observableArray([])
            , introText: ko.observable("")
            , isReviewItemDeleteVisible: ko.observable(false)
            , selectedTab: ko.observable('article')
            , permissions: ko.observableArray(this.initPermissions([]))
            ,onClickEditReviewItem: function (value, data, event) {huit_neuf_this.onClickEditReviewItem(value);}
            ,onClickAddProduct: function (value, data, event) {huit_neuf_this.caller.showReviewItemForm();}
            ,onClickDeleteReviewItem: function (value, index, event) {huit_neuf_this.onClickDeleteReviewItem(value, index);}
            ,onClickConfirmReviewItemDelete: function (value, data, event) {huit_neuf_this.onClickConfirmReviewItemDelete();}
            ,onClickCancelReviewItemDelete: function (value, data, event) {huit_neuf_this.onClickCancelReviewItemDelete();}
            ,isEditorDisable: function (value, event) { huit_neuf_this.isEditorDisable(); }
        }
    }

    public getViewModelForRequest(){

        return{

        }
    }


    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions);
    }

    public setSelectedTab(selectedTab) {

        this.getTemplateViewModel().selectedTab(selectedTab);
    }

    public getReviewItems() {

        return this.getTemplateViewModel().reviewItems();
    }

    public getReviewItemsToDelete() {

        return this.getTemplateViewModel().reviewItemsToDelete();
    }

    public setReviewItemsToDelete(toDeleteNew: Array<number>) {

        let toDelete = this.getTemplateViewModel().reviewItemsToDelete();
        toDeleteNew.forEach((td) => toDelete.push(td));

        let uniqueIds = toDelete.filter(function(item, pos){
            return toDelete.indexOf(item) == pos && item;
        });

        return this.getTemplateViewModel().reviewItemsToDelete(uniqueIds);
    }

    public markReviewItemsAsToDelete(): void {

        let reviewItems = this.getReviewItems();
        let toDelete = this.getTemplateViewModel().reviewItemsToDelete();
        reviewItems.forEach((td) => toDelete.push(td.id));

        let uniqueIds = toDelete.filter(function(item, pos){
            return toDelete.indexOf(item) == pos;
        });



        this.setReviewItemsToDelete(uniqueIds);
    }

    public setIdTemplate(idTemplate): void{

        this.getTemplateViewModel().idTemplate(idTemplate);
    }

    public setIdStatus(idStatus): void{

        this.getTemplateViewModel().idStatus(idStatus);
    }

    public setEditorId(editorId): void{

        this.getTemplateViewModel().editorId(editorId);
    }

    public getIdTemplate(): void{

        return this.getTemplateViewModel().idTemplate();
    }

    public setReviewItems(reviewItems, destination = "article"): void{


        if( (!reviewItems || (reviewItems && reviewItems.length == 0) ) ){//&& destination != "sandbox"

            this.getTemplateViewModel().reviewItems([]);
        }

        //TODO: Investigate why this is called twice on Save And Preview
        let productTag, tagType, specValues, specs, spec;

        if (typeof reviewItems != "undefined" &&  reviewItems.length > 0)
        {
            // sort reviewItems by position from 1st to last
            reviewItems = reviewItems.sort((a, b) => a.position - b.position);
            for(let i = 0; i < reviewItems.length; i++)
            {

                reviewItems[i].tagAwardClass = reviewItems[i].award && reviewItems[i].award.name ? 'i-' + reviewItems[i].award.name.replace(' ', '-').toLowerCase() : "";
                reviewItems[i].idTagType = reviewItems[i].tag ? reviewItems[i].tag.idType: 0;

                if(!reviewItems[i].position){
                    reviewItems[i].position = i + 1;
                }
                specs = []
                spec = {};
                productTag = reviewItems[i].tag
                specValues =  ( productTag && typeof productTag.specifications_extra != "undefined" && productTag.specifications_extra.length > 0) ?  JSON.parse( JSON.stringify(productTag.specifications_extra)) : [];

                tagType = (productTag && productTag.type ) ? productTag.type : null;


                if ( tagType && typeof tagType.fields != "undefined" )
                {
                    tagType.fields.forEach( field => {

                        spec = {fieldId: field.id, label: field.label, data: "",  dataType: field.dataType, isAdded: false}; //TODO: Investigate what to do with isAdded

                        if (productTag)
                        {
                            for (let i=0; i< specValues.length; i++ )
                            {
                                if (specValues[i].idField == field.id )
                                {

                                    spec['data'] = specValues[i].value;
                                    specValues.splice(i,1);
                                    break;
                                }
                            }
                        }

                        specs.push(spec);

                    } )
                    reviewItems[i].tagSpecifications = specs;

                }
            }
            this.getTemplateViewModel().reviewItems(reviewItems);
            if(this.getTemplateViewModel().idStatus() != 6 || (this.getTemplateViewModel().idStatus() == 6 && this.getTemplateViewModel().permissions()['article_edit_publishingControl'].write && this.getTemplateViewModel().selectedTab() == 'article' && !this.idElement.toLowerCase().includes('sandbox')) || this.idElement.toLowerCase().includes('sandbox')){
                this.onLoadTemplate('#' + this.idElement + ' #review-item-list .img-article-item', this.reorderReviewItems.bind(this));
            }

        }


    }



    private onLoadTemplate (dragItemSelector, sortFunction) {

        var parent = this;

        var dragSrcEl = null;

        function handleDragStart(e) {
            // Target (this) element is the source node.
            dragSrcEl = this;

            //e.dataTransfer.setData('text', 'foo');
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('text/html', this.outerHTML);

            this.classList.add('dragElem');
        }
        function handleDragOver(e) {
            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            let huit_neuf_this = this;
            //var dragItems = document.querySelectorAll('[draggable=true]');
            var dragItems = document.querySelectorAll(dragItemSelector);
            let index = 0;
            let found = false;
            for(let item of dragItems){
                if(dragSrcEl == item){

                    huit_neuf_this.classList.add('after');
                    huit_neuf_this.classList.remove('before');
                    found = true;
                    break;
                }
                if(this == item){

                    huit_neuf_this.classList.add('before');
                    huit_neuf_this.classList.remove('after');
                    found = true;
                    break;
                }
            }

            if(!found){
                this.classList.add("before");
            }

            e.dataTransfer.dropEffect = 'move';  // See the section on the DataTransfer object.

            return false;
        }

        function handleDragEnter(e) {
            // this / e.target is the current hover target.
            //this.classList.add('over');

            //this.classList.add('before');
        }

        function handleDragLeave(e) {
            this.classList.remove('before');
            this.classList.remove('after');  // this / e.target is previous target element.
        }

        function handleDrop(e) {
            // this/e.target is current target element.

            if (e.stopPropagation) {
                e.stopPropagation(); // Stops some browsers from redirecting.
            }

            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            // Don't do anything if dropping the same column we're dragging.
            if (dragSrcEl != this) {


                var dropHTML = e.dataTransfer.getData('text/html');

                if(dropHTML.includes("<li")){

                    let targetPos = this.getAttribute("position");

                    let srcPos = dragSrcEl.getAttribute("position")

                    for(let child of this.parentNode.childNodes){

                        if(child == dragSrcEl){
                            this.parentNode.removeChild(dragSrcEl);
                        }
                    }

                    if(this.classList.contains("before")){
                        this.insertAdjacentHTML('beforebegin',dropHTML);
                        var dropElem = this.previousElementSibling;
                    }else{
                        this.insertAdjacentHTML('afterend',dropHTML);
                        var dropElem = this.nextElementSibling;
                    }

                    //parent.performReviewItemsOrderChange(srcPos, targetPos);
                    console.log(parent.getTemplateViewModel().reviewItems())
                    addDnDHandlers(dropElem);
                    //this.reorderImages();
                }



            }
            sortFunction(parent);
            this.classList.remove('before');
            this.classList.remove('after');
            return false;
        }



        function handleDragEnd(e) {
            // this/e.target is the source node.
            this.classList.remove('before');
            this.classList.remove('after');

            [].forEach.call(cols, function (col) {
                col.classList.remove('before');
                col.classList.remove('after');
            });
        }

        function addDnDHandlers(elem) {
            elem.addEventListener('dragstart', handleDragStart, false);
            elem.addEventListener('dragenter', handleDragEnter, false)
            elem.addEventListener('dragover', handleDragOver, false);
            elem.addEventListener('dragleave', handleDragLeave, false);
            elem.addEventListener('drop', handleDrop, false);
            elem.addEventListener('dragend', handleDragEnd, false);

        }

        //var dragItems = document.querySelectorAll('[draggable=true]');
        var cols = document.querySelectorAll(dragItemSelector);
        [].forEach.call(cols, addDnDHandlers);
    }

    protected reorderReviewItems(huit_neuf_this){
        let reviewItems = [];
        reviewItems = huit_neuf_this.getTemplateViewModel().reviewItems();

        let selector = '#' + huit_neuf_this.idElement + ' #review-item-list .img-article-item';
        let liElements = document.querySelectorAll(selector);

        //reorder the images based on HTML order
        let newReviewItems = []
        liElements.forEach((element, index) => {

            let reviewItem = reviewItems.find((i, index) => index === Number(element.id));
            if(reviewItem){
                reviewItem.position = index + 1;
                newReviewItems.push(reviewItem);
            }
        });

        huit_neuf_this.getTemplateViewModel().reviewItems([]);
        huit_neuf_this.getTemplateViewModel().reviewItems(newReviewItems);
        huit_neuf_this.onLoadTemplate(selector, huit_neuf_this.reorderReviewItems.bind(huit_neuf_this));
    }




    protected onClickConfirmReviewItemDelete() {

        let index = this.getTemplateViewModel().reviewItemToDelete();
        this.setIsReviewItemDeleteVisible(false);


        if (index > -1) {
            this.getTemplateViewModel().reviewItemToDelete(null);
            this.getTemplateViewModel().reviewItemsToDelete.push(this.getTemplateViewModel().reviewItems()[index].id);
            this.getTemplateViewModel().reviewItems.splice(index, 1);
            this.reorderReviewItems(this)
            this.onLoadTemplate('#' + this.idElement + ' #review-item-list .img-article-item', this.reorderReviewItems);
        }
    }

    protected onClickCancelReviewItemDelete() {

        this.setIsReviewItemDeleteVisible(false);
    }

    public setIsReviewItemDeleteVisible(value) {

        this.getTemplateViewModel().isReviewItemDeleteVisible(value);
    }

    protected onClickDeleteReviewItem(index, value) {

        this.getTemplateViewModel().reviewItemToDelete(index);
        this.setIsReviewItemDeleteVisible(true);
    }

    public onClickEditReviewItem(index) {

        this.caller.onClickEditReviewItem(index, this.getTemplateViewModel().reviewItems())
    }

    public addReviewItem(reviewItem, index) {

        if(index == undefined) {

            reviewItem.position = this.getTemplateViewModel().reviewItems().length + 1;
            this.getTemplateViewModel().reviewItems.push(reviewItem);
        } else {
            let reviewItems = this.getTemplateViewModel().reviewItems();
            reviewItem.position = index + 1;
            reviewItems[index] = reviewItem;
            this.getTemplateViewModel().reviewItems(reviewItems);
        }
    }

    public isEditorDisable() {

        let result = false;
        if(this.getTemplateViewModel().idStatus() == 6 && !this.getTemplateViewModel().permissions()['article_edit_publishingControl'].write && this.getTemplateViewModel().selectedTab() == 'article' && !this.idElement.toLowerCase().includes('sandbox')){
            result = true;
        }

        if (this.idElement.toLowerCase().includes('sandbox')){
            this.caller.setSandboxIntroTextEditorStatus(result)
        } else {
            this.caller.setIntroTextEditorStatus(result)
        }
    }

}


// WEBPACK FOOTER //
// ./js/components/templates/productReview_template.ts